import { css } from "emotion";
import H3 from "../../../components/global/H3";
import P from "../../../components/global/P";
import Button from "../../../components/global/Button";
import { max } from "../../../utils/CssUtils";

const humans = require("../../../assets/FeaturesAndPricing/theTeam.png");

const wrapper = css({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  maxWidth: 1040,
  margin: "0 auto",
  [max(800)]: {
    display: "block"
  }
});

const textWrapper = css({
  maxWidth: 480,
  marginRight: 10,
  flexShrink: 1,
  h3: {
    marginBottom: 16
  },
  p: {
    marginBottom: 24
  },
  [max(800)]: {
    marginRight: 0,
    marginBottom: 32
  }
});

const image = css({
  flexShrink: 2,
  maxWidth: 480,
  maxHeight: 250,
  minWidth: 340,
  objectFit: "contain",
  [max(800)]: {
    width: "100%",
    minWidth: 0
  }
});

const SpeakToHumans = () => {
  return (
    <div className={wrapper}>
      <div className={textWrapper}>
        <H3>Speak to humans, not bots</H3>
        <P>
          Every new event organiser gets a call from the humans at Humanitix,
          who are available 7 days a week. Yes, actual humans. Yes, actually
          calling you.
        </P>
        <Button
          link="https://meetings.hubspot.com/adam-long1/humanitix-demo-see-how-to-give-your-events-impact"
          size="large"
        >
          Request a demo
        </Button>
      </div>
      <img
        className={image}
        src={humans}
        alt="A photo of people working at Humanitix"
      />
    </div>
  );
};

export default SpeakToHumans;
